<script>
export const group = 'Bottom'
</script>

<script setup>
import { frames } from '../../../utils/frames'
import useDisappearable from '../../../composables/useDisappearable'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const circleElement = ref(null)
const imageElement = ref(null)

let circlePulseTimeline = null

const timelineSuperTitle = ref(null)
const timelineSuperTitleOut = ref(null)
const timelineTitle = ref(null)
const timelineTitleOut = ref(null)

onMounted(() => {
  circlePulseTimeline = gsapTimeline({ repeat: -1, yoyo: true }).fromTo(circleElement, { scale: 1 }, { scale: 1.08, duration: frames(200, 50), ease: 'sine.inOut', transformOrigin: 'right center' })

  gsapTimeline({ name: 'HeadlineSmall' })
    .from(circleElement, { scale: 0, duration: frames(25, 50), ease: 'back.out(1.7)' })
    .add(timelineSuperTitle, `<${frames(3, 50)}`)
    .add(timelineTitle, `<${frames(10, 50)}`)
    .from(imageElement, { scale: 0, rotate: -10, duration: frames(25, 50), ease: 'back.out(1.7)' }, `<${frames(6, 50)}`)
    .add(circlePulseTimeline, `+=${frames(25, 50)}`)
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  circlePulseTimeline?.kill()

  return await gsapTimeline({ name: 'HeadlineSmall - End' })
    .add(timelineTitleOut.value(), `<`)
    .add(timelineSuperTitleOut.value(), `<${frames(4)}`)
    .to(imageElement, { scale: 0, rotate: 10, duration: frames(15, 50), ease: 'power2.in' }, `<${frames(2)}`)
    .to(circleElement, { scale: 0, duration: frames(15, 50), ease: 'power2.in' }, `<${frames(8)}`)
})
</script>

<template>
  <div ref="circleElement" class="absolute -bottom-[600px] right-0 rounded-full size-[800px] border-[150px] border-joe-cr-blue-darker" />
  <div class="-mb-20 flex justify-end items-end space-x-12">
    <div class="text-white text-right space-y-2">
      <TextSlideUpFade class="text-7xl font-bold text-shadow-glow" :text="item.properties.superTitle" @timeline="timelineSuperTitle = $event" @timelineOut="timelineSuperTitleOut = $event" />
      <TextSlideUpFade class="text-4xl font-bold text-shadow-glow" :text="item.properties.title" @timeline="timelineTitle = $event" @timelineOut="timelineTitleOut = $event" />
    </div>
    <img v-if="item.properties.image" ref="imageElement" :src="item.properties.image" class="w-96 relative rotate-3 border-[6px] border-white drop-shadow-2xl object-cover -mb-2" />
  </div>
</template>
